// login.js

import {
    getService,
    postService
} from '../api/service.js'
/**
 * name 登录
 * time 2021-09-07
 * param userName String 账号
 * param password String 密码
 * return String token
 * */
// 修改密码
export const adminUpdatePwdPost = params => {
    return postService('/api/jfy/adminUpdatePwd', params)
}
// 管理员列表
export const getAdminUserInfoListPost = params => {
    return postService('/api/jfy/getAdminUserInfoList', params)
}
// 角色列表
export const getJfyRuleListPost = params => {
    return postService('/api/jfy/getJfyRuleList', params)
}
// boss列表
export const getBossListPost = params => {
    return postService('/api/jfy/getBossList', params)
}
// 管理员详情
export const getAdminUserInfoPost = params => {
    return postService('/api/jfy/getAdminUserInfo', params)
}
// 管理员修改
export const updateAdminUserInfoPost = params => {
    return postService('/api/jfy/updateAdminUserInfo', params)
}
// 管理员添加
export const addAdminUserInfoPost = params => {
    return postService('/api/jfy/addAdminUserInfo', params)
}
// 管理员删除
export const adminUserInfoDeletePost = params => {
    return postService('/api/jfy/adminUserInfoDelete', params)
}
// 角色添加
export const addJfyRulePost = params => {
    return postService('/api/jfy/addJfyRule', params)
}
// 角色修改
export const updateJfyRulePost = params => {
    return postService('/api/jfy/updateJfyRule', params)
}

// 角色删除
export const deleteJfyRulePost = params => {
    return postService('/api/jfy/deleteJfyRule', params)
}
// boss权限设置列表(接口同景区列表)
export const getScenicListPost = params => {
    return postService('/api/jfy/getScenicList', params)
}
// boss添加权限
export const bossAddPermissionPost = params => {
    return postService('/api/jfy/bossAddPermission', params)
}
// 角色权限列表
export const getJfyAuthListPost = params => {
    return postService('/api/jfy/getJfyAuthList', params)
}
// 角色添加权限

export const ruleAddJfyAuth = params => {
    return postService('/api/jfy/ruleAddJfyAuth', params)
}
/**
 * name 登出
 * time 2021-09-07
 * */
export const codeGet = params => {
    return getService('/api/auth/getCaptcha', params)
}

// boss 已授权

export const bossPowerPermissionList = params => {
    return postService('/api/jfy/bossPowerPermissionList', params)
}
// boss 未授权

export const getBossScenicList = params => {
    return postService('api/jfy/getBossScenicList', params)
}

// 添加在线客服信息
export const addServiceContent = params => {
    return postService('api/jfy/addServiceContent', params)
}
// 客服列表
export const getServiceList = params => {
    return postService('api/jfy/getServiceList', params)
}
// 客服数据删除暂停发布
export const changeState = params => {
    return postService('api/jfy/changeState', params)
}
// 获取通知列表
export const getNoticeList = params => {
    return postService('api/jfy/getNoticeList', params)
}
//  发布通知
export const sendAdminNotice = params => {
    return postService('api/jfy/sendAdminNotice', params)
}
// 
//  通知删除
export const deleteNotice = params => {
    return postService('api/jfy/deleteNotice', params)
}

// 客服列表修改排序

export const changeServiceSort = params => {
    return postService('api/jfy/changeServiceSort', params)
}
